import script from "./PersonalizedBooks.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalizedBooks.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalizedBooks.vue?vue&type=style&index=0&id=1988d422&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1988d422"]])

export default __exports__